export default "__VITE_ASSET__fa4d3ab3__"